import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styles from "../setting.module.css";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import { ReactComponent as VectorSuccess } from "../../../utils/assets/Vector_success.svg";
import {
    centeredModalBoxSx,
    modalBackdropProps,
} from "../../../utils/styles/modal.overlay";

const style = centeredModalBoxSx({
    width: 700,
    maxWidth: "calc(100vw - 48px)",
    overflow: "hidden",
    p: "1.5rem 1.5rem 0",
});

export default function SuccessModal(props) {
    const { setOpen, open, setOpenedEmail } = props;

    useEffect(() => {
        setOpenedEmail(false);
        // eslint-disable-next-line
    }, [open]);

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropProps={modalBackdropProps}
            >
                <Box sx={style}>
                    <div className={styles.successModalBody}>
                        <div className={styles.successModalCloseRow}>
                            <ModalCloseButton
                                style={{ position: "static" }}
                                onClick={() => setOpen(false)}
                            />
                        </div>
                        <div className={styles.successModalIcon}>
                            <VectorSuccess />
                        </div>
                        <p className={styles.successModalMessage}>
                            Your request has been sent to the Admin for approval. You
                            will receive a notification once Admin approves.
                        </p>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
